'use strict'

import React, { useCallback } from 'react'
import { useModal } from '../../../_components/Modal'
import { useModifyClassList } from '../../../common/utils/CSSUtils'
import ColumnInfoModal from './ColumnInfoModal'

/**
 * 項目情報モーダルを標準 useModal + promisify で表示するフック。
 *
 * @returns {(column: object) => Promise<void>}
 */
export function useColumnInfoModal() {
  const showModal = useModal()
  const { promisify } = useModifyClassList('.modal-window', ['w-[650px]'])

  return useCallback(
    (column) => {
      return promisify((res) => {
        showModal({
          title: '項目情報',
          body: <ColumnInfoModal column={column} />,
          button: [
            {
              name: '閉じる',
              className: 'footer-btn button_base',
              click: () => res(),
              close: true
            }
          ],
          onClose: res,
          isCancel: false,
          isWide: false,
          modalStyle: { width: '650px' }
        })
      })
    },
    [showModal, promisify]
  )
}
